import { request } from '../request';

export type FavoriteContentType =
  | 'journey'
  | 'documenttemplate'
  | 'journeyform'
  | 'journeyview'
  | 'companytravellerview';

export type CompanyUserFavorite = {
  shortId: string;
  contentType: FavoriteContentType;
  objectShortId: string;
  name: string;
  workspaceId: string;
  workspaceName?: string;
  journeyName?: string;
  journeyShortId?: string;
};

export const loadCompanyUserFavoriteList = async () => {
  const response = await request.get<CompanyUserFavorite[]>('v1/favorites/');
  return response.data;
};

export const deleteCompanyUserFavorite = async (shortId: CompanyUserFavorite['shortId']) => {
  const response = await request.delete(`v1/favorites/${shortId}/`);
  return response.data;
};

export const addCompanyUserFavorite = async (
  data: Pick<CompanyUserFavorite, 'contentType' | 'objectShortId' | 'journeyShortId'>
) => {
  const response = await request.post('v1/favorites/', data);
  return response.data;
};
